export interface ILensObj {
    step: number;
    latestStep: number; //选到的最后一个步骤
    price: number;
    isDecentered: boolean;
    canChangeNextStep: boolean;
    isShowSelectWarning: boolean;
    lensRx: Record<string, any>;
    conditions: any;
}

export type State = ILensObj;

export type ILensObjnAction = State & Action;

export type Action = {
    changeStep: (step: number) => void;
    changePrice: (price: number) => void;
    isDecen: () => void;
    setlensRx: (rx: Record<string, any>) => void;
    notDecen: () => void;
    changesetlens: (conditions: any) => void;
    initLastStep: (step?: number) => void;
    showWarning: () => void;
    hideWarning: () => void;
};

export const initialState: State = {
    step: 1,
    latestStep: 1, //选到的最后一个步骤
    price: 0,
    isDecentered: false,
    canChangeNextStep: false,
    isShowSelectWarning: false,
    lensRx: {},
    conditions: {},
};
